import {
  getUploadPresignedUrl,
  uploadFileOnPresignedUrl,
  getDownloadPresignedUrl,
} from "../setup/api/services/file";
import { AWS_S3_BASE_URL, AWS_S3_BUCKET } from "./constants";
import { EUploadImageType, UploadProgress, IUploadResult } from "./enums";
import S3, { ManagedUpload } from "aws-sdk/clients/s3";

export const DOWNLOAD_URL_EXPIRATION = 604800; // 7 days

const s3 = new S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECURITY_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

export const uploadFileWithPresignedUrl = async (
  file: File,
  type: EUploadImageType,
  id: string | number,
  progressCallback?: (progress: UploadProgress) => void
): Promise<IUploadResult> => {
  try {
    const timestamp =
      new Date().getUTCMilliseconds() + Math.random().toString(16).slice(2);

    const name = file.name;
    console.log("image:", file);
    console.log("name:", name);
    const lastDot = name.lastIndexOf(".");

    const ext = name.substring(lastDot + 1);
    const key =
      type === EUploadImageType.CONTRACT
        ? `images/contracts/${id}`
        : type === EUploadImageType.ORGANIZATION
        ? `images/organizations/${id}`
        : `images/users/${id}`;
    const params = {
      Bucket: AWS_S3_BUCKET,
      Key: `${key}/${ext === "pdf" ? `${name}` : `${`${timestamp}.${ext}`}`}`,
      Body: file,
      ACL: "public-read",
    };

    const presignedUrl = await getUploadPresignedUrl({
      bucket_name: params.Bucket,
      object_name: params.Key,
      expiration: 36000,
      is_public: true,
    });

    const response = await uploadFileOnPresignedUrl({
      presignedUrl,
      file,
      progressCallback,
    });
    console.log("response:", response);

    if (response.status !== 200) {
      throw new Error("Failed to upload file");
    }

    const downloadUrl = await getDownloadPresignedUrl({
      bucket_name: params.Bucket,
      object_name: params.Key,
      expiration: DOWNLOAD_URL_EXPIRATION,
    });

    return {
      url: downloadUrl,
      bucket: params.Bucket,
      key: params.Key,
    };
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const uploadFile = async (
  image: File,
  type: EUploadImageType,
  id: string | number,
  progressCallback?: (progess: ManagedUpload.Progress) => void
): Promise<string> => {
  try {
    const timestamp =
      new Date().getUTCMilliseconds() + Math.random().toString(16).slice(2);

    const name = image.name;
    const lastDot = name.lastIndexOf(".");

    const ext = name.substring(lastDot + 1);
    const key =
      type === EUploadImageType.CONTRACT
        ? `images/contracts/${id}`
        : `images/users/${id}`;
    const params = {
      Bucket: AWS_S3_BUCKET,
      Key: `${key}/${ext === "pdf" ? `${name}` : `${`${timestamp}.${ext}`}`}`,
      Body: image,
      ACL: "public-read",
    };
    return await new Promise((resolve) => {
      const uploadRequest = s3.upload(
        params,
        function (err: unknown, data: unknown) {
          if (err) {
            throw err;
          }
          resolve(`${AWS_S3_BASE_URL}${params.Key}`);
        }
      );
      if (progressCallback)
        uploadRequest?.on("httpUploadProgress", progressCallback);
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};
